var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"answer"},[_vm._v(_vm._s(_vm.$t("faqTab.watching.devicesAmount.changeYourPassword")))]),_c('a',{staticClass:"link-text",attrs:{"href":_vm.link,"target":"_blank"}},[_vm._v(_vm._s(_vm.link))])])}
var staticRenderFns = []

export { render, staticRenderFns }